import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { message, FloatButton } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { PiSelection } from "react-icons/pi";

import Header from "../../component/header";
import Footer from "../../component/footer/footer";
import SubHeader from "./subHeader";
import PageHeader from "./components/pageHeader";
// import BoxAdd from "../../component/adds/boxAdd";
// import GoogleAds from "../../component/adds/googleAdds";

import { API } from "../../Config/API";
import { POST } from "../../utils/apiCalls";

import CropBox from "./components/cropBox";
import SelectionBox from "./components/selectionBox";

import { getURL } from "../../utils/getCdnURL";
import CropImage from "./helpers/cropImage";
import SharePopup from "./components/sharePopup";
import ZoomPopup from "./components/zoomPopup";

import { useSubscriptionCheck } from "../../hooks/useSubscriptionCheck";
import SubscriptionModal from "../../components/SubscriptionModal";
import RenewalModal from "../../components/RenewalModal";

function DetailScreen() {
  const params = useParams();
  const navigate = useNavigate();
  const { status: subStatus, daysLeft, endDate } = useSubscriptionCheck();
  const [showRenewal, setShowRenewal] = useState(false);
  // Subscription locking temporarily disabled
  // const subBlockType: "expired" | "expiring_soon" | "none" | null =
  //   subStatus === "expired" || subStatus === "none"
  //     ? subStatus
  //     : null;
  const subBlockType: "expired" | "expiring_soon" | "none" | null = null;
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);

  const [activeIndex, setActiveIndex] = useState(0);
  const [activePage, setActivePage] = useState<any>(null);
  const [activePreview, setactivePreview] = useState(false);
  const [activeZoom, setActiveZoom] = useState<any>(false);
  const [cropActive, setCropActive] = useState(false);

  const [cropComplete, setCropComplete] = useState(false);
  const [cropValue, setCropValue] = useState({});

  const [activeShare, setActiveShare] = useState(false);
  const [cropFile, setCropFile] = useState(null);
  const [isScrolledPast32, setIsScrolledPast32] = useState(false);
  const [isScrolledPast15, setIsScrolledPast15] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // **MARKED UPDATE** - Touch/Swipe state variables for mobile navigation
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);
  const [isSwipeEnabled, setIsSwipeEnabled] = useState(true);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile(); // initial check
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const viewportHeight = window.innerHeight;
      const fullHeight = document.body.scrollHeight;

      const scrollPercentage = Math.round(
        (scrollTop / (fullHeight - viewportHeight)) * 100,
      );

      // 23% logic for PageHeader
      if (scrollPercentage >= 23 && !isScrolledPast32) {
        setIsScrolledPast32(true);
      } else if (scrollPercentage < 23 && isScrolledPast32) {
        setIsScrolledPast32(false);
      }

      // 15% logic for Arrow
      if (scrollPercentage >= 15 && !isScrolledPast15) {
        setIsScrolledPast15(true);
      } else if (scrollPercentage < 15 && isScrolledPast15) {
        setIsScrolledPast15(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isScrolledPast32, isScrolledPast15]);

  // **MARKED UPDATE** - Touch event handlers for mobile swipe navigation
  const handleTouchStart = (e: React.TouchEvent) => {
    if (!isMobile || !isSwipeEnabled || cropActive || activeZoom || activeShare)
      return;

    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isMobile || !isSwipeEnabled || cropActive || activeZoom || activeShare)
      return;

    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!isMobile || !isSwipeEnabled || cropActive || activeZoom || activeShare)
      return;
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      // Swipe left - go to next page
      clickArrow("add");
    }
    if (isRightSwipe) {
      // Swipe right - go to previous page
      clickArrow("remove");
    }

    // Reset touch states
    setTouchStart(null);
    setTouchEnd(null);
  };

  // **MARKED UPDATE** - Disable swipe when modals or crop mode is active
  useEffect(() => {
    setIsSwipeEnabled(!cropActive && !activeZoom && !activeShare);
  }, [cropActive, activeZoom, activeShare]);

  // Cleanup effect to reset crop state when component unmounts
  useEffect(() => {
    return () => {
      setCropActive(false);
      setCropComplete(false);
      setCropValue({});
    };
  }, []);

  // devtool
  window.addEventListener("keydown", function (event) {
    if (event.ctrlKey && event.shiftKey && event.key === "I") {
      event.preventDefault();
      message.error("Developer Tools are disabled.");
    }
  });

  // right click
  document.addEventListener("contextmenu", (event) => event.preventDefault());

  useEffect(() => {
    const edition = params?.edition;
    const date = params?.date;
    const page = params?.page;
    const epaper_id = params?.epaper_id;
    setActiveIndex(0);
    setIsLoading(true);
    loadData(edition, date, page, epaper_id);
    window.scrollTo(0, 0);
  }, [params]);

  const loadData = async (
    edition: any,
    date: any,
    page: any,
    epaper_id: any,
  ) => {
    try {
      setIsLoading(true);
      let url = API.EPAPER;
      let obj = {
        type: "all",
        edition: edition,
        id: epaper_id,
        limit: 8,
        createdAt: moment(date).format("YYYY-MM-DD"),
      };
      const response: any = await POST(url, obj);
      if (response?.length) {
        setData(response[0]);
        ChangePage(response[0]?.epapercollections[0]);
      } else {
        setData([]);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const clickArrow = (type: any) => {
    try {
      setIsLoading(true);
      if (type === "add") {
        var totalPages = Number(data?.epapercollections?.length);
        var num = activeIndex + 1;
        if (num >= totalPages) {
          setActiveIndex(0);
          // setActiveIndex(totalPages);
        } else {
          setActiveIndex(num);
        }
      } else {
        var num = activeIndex - 1;
        if (num < 0) {
          var totalPages = Number(data?.epapercollections?.length) - 1;
          setActiveIndex(totalPages);
          // setActiveIndex(0);
          // **MARKED UPDATE** - Show different message for mobile swipe vs desktop click
        } else {
          setActiveIndex(num);
        }
      }
      setTimeout(() => {
        setIsLoading(false);
      }, 5);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data?.epapercollections?.length) {
      setIsLoading(true);
      let item = data?.epapercollections[activeIndex];
      ChangePage(item);
    }
  }, [activeIndex]);

  const ChangePage = async (file: any) => {
    try {
      setActivePage(null);
      // Reset crop state completely when changing pages
      setCropActive(false);
      setCropComplete(false);
      setCropValue({});
      if (file?.imageUrl) {
        setActivePage(file);
      }
      setIsLoading(false);
    } catch (err) {
      console.log("err", err);
      setIsLoading(false);
    }
  };

  const onFinishCrop = async (value: any) => {
    try {
      setIsLoading2(true);
      setActiveShare(true);
      let active = activePage;
      let cropedFile: any = await CropImage(
        value?.area,
        value?.ref,
        activePage?.imageUrl,
        params?.edition,
      );
      setCropFile(cropedFile);
      setIsLoading2(false);
      setActivePage({});
      setTimeout(() => {
        setActivePage(active);
      }, 5);
    } catch (err) {
      setActiveShare(false);
      setIsLoading2(false);
      console.log("err", err);
    }
  };

  // **MARKED UPDATE** - Prevent image dragging handler
  const preventImageDrag = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  useEffect(() => {
    // **MARKED UPDATE** - Disable drag on all images in detail screen
    const images = document.querySelectorAll(".detailScreen img");
    images.forEach((img) => {
      const imageElement = img as HTMLImageElement;
      imageElement.draggable = false;
      imageElement.addEventListener("dragstart", preventImageDrag);
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        const imageElement = img as HTMLImageElement;
        imageElement.removeEventListener("dragstart", preventImageDrag);
      });
    };
  }, [activePage]);

  if (subBlockType) {
    return (
      <div>
        <Header />
        <div style={{ minHeight: "60vh" }} />
        <Footer />
        <SubscriptionModal
          type={subBlockType}
          visible={true}
          daysLeft={daysLeft}
          endDate={endDate}
          onClose={() => navigate("/")}
          onRenew={() => setShowRenewal(true)}
        />
        <RenewalModal
          visible={showRenewal}
          onClose={() => setShowRenewal(false)}
        />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <SubHeader edition={params?.edition} date={params?.date} />
      <div
        className="detailScreen"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="detailScreen-arrow-leftBox">
          <div
            className={`detailScreen-arrow-left ${
              isScrolledPast15 ? "fixed-arrow" : ""
            }`}
            onClick={() => clickArrow("remove")}
          >
            <IoIosArrowBack size={40} />
          </div>
        </div>
        <Container fluid={false}>
          <Row>
            {/* <Col sm={2} xs={12}>
              <GoogleAds />
            </Col> */}
            <Col sm={12} xs={12}>
              {/* <BoxAdd /> */}
              {isLoading ? (
                <div className="detailScreen-loading">Loading . . . </div>
              ) : (
                <div>
                  <PageHeader
                    isScrolledPast32={isMobile ? false : isScrolledPast32}
                    totalPage={data?.epapercollections}
                    activeIndex={activeIndex}
                    acitvePreview={activePreview}
                    cropActive={cropActive}
                    activeZoom={activeZoom}
                    changePreview={(value: any) => setactivePreview(value)}
                    changeIndex={(value: any) => setActiveIndex(value)}
                    clickArrow={(value: any) => clickArrow(value)}
                    setCropActive={() => setCropActive(!cropActive)}
                    setActiveZoom={() => setActiveZoom(!activeZoom)}
                  />
                  {/* **MARKED UPDATE** - Added swipe indicator for mobile users */}
                  {isMobile && isSwipeEnabled && (
                    <div className="mobile-swipe-indicator">
                      <div className="swipe-hint">
                        ← Swipe to navigate pages →
                      </div>
                    </div>
                  )}
                  <div className="detailScreen-box">
                    {cropActive ? (
                      <CropBox
                        page={activePage}
                        onChange={(value: any) => {
                          setCropValue(value);
                          if (value) {
                            setCropComplete(true);
                          } else {
                            setCropComplete(false);
                            setCropActive(false);
                          }
                        }}
                      />
                    ) : (
                      <SelectionBox
                        page={activePage}
                        onChange={(value: any) => {
                          setCropValue(value);
                          if (value) onFinishCrop(value);
                        }}
                      />
                    )}
                  </div>
                  <div className="detailScreen-box3">
                    Page - {activeIndex + 1}
                    {isMobile && data?.epapercollections?.length && (
                      <span className="mobile-page-info">
                        {" "}
                        of {data.epapercollections.length}
                      </span>
                    )}
                  </div>
                  {/* <GoogleAds /> */}
                </div>
              )}
            </Col>
            {/* <Col sm={2} xs={12}>
              <GoogleAds />
            </Col> */}
          </Row>
        </Container>
        <div className="detailScreen-arrow-rightBox">
          <div
            className={`detailScreen-arrow-left ${
              isScrolledPast15 ? "fixed-arrow-right" : ""
            }`}
            onClick={() => clickArrow("add")}
          >
            <IoIosArrowForward size={40} />
          </div>
        </div>
      </div>
      {cropComplete ? (
        <FloatButton
          style={{ width: 80, height: 60, marginBottom: 20 }}
          icon={
            <div style={{ marginRight: 5 }}>
              <PiSelection size={25} />
            </div>
          }
          description={"Create"}
          shape="square"
          type="primary"
          onClick={() => onFinishCrop(cropValue)}
        />
      ) : null}

      {activeZoom ? (
        <ZoomPopup
          show={activeZoom}
          onClose={() => {
            setActiveZoom(false);
            // Reset crop state when zoom is closed to ensure clean state
            if (cropActive) {
              setCropActive(false);
              setCropComplete(false);
              setCropValue({});
            }
          }}
          src={getURL(activePage?.imageUrl)}
        />
      ) : null}

      {activeShare ? (
        <SharePopup
          loading={isLoading2}
          file={cropFile}
          edition={params?.edition}
          page={activeIndex}
          date={params?.date}
          visible={activeShare}
          onClose={() => {
            setActiveShare(false);
            setCropActive(false);
            setCropComplete(false);
            setCropValue({});
          }}
        />
      ) : null}

      {!isMobile && <Footer />}
    </div>
  );
}

export default DetailScreen;
